/**
 * Real-estate leasing permission keys (catalog `lease.*`, docs/contracts/leasing.md §5). The UI hides what a key does not
 * allow; the API checks the same keys.
 */
export const leasePermissions = {
  moduleView: "lease.leasing.view",
  propertyView: "lease.property.view",
  propertyCreate: "lease.property.create",
  propertyUpdate: "lease.property.update",
  propertyDelete: "lease.property.delete",
  unitView: "lease.unit.view",
  unitCreate: "lease.unit.create",
  unitUpdate: "lease.unit.update",
  unitDelete: "lease.unit.delete",
  contractView: "lease.contract.view",
  contractCreate: "lease.contract.create",
  contractUpdate: "lease.contract.update",
  contractActivate: "lease.contract.post",
  contractDelete: "lease.contract.delete",
  contractPrint: "lease.contract.print",
  contractBill: "lease.contract.bill",
  contractDeposit: "lease.contract.deposit",
  contractRefund: "lease.contract.refund",
  contractTerminate: "lease.contract.terminate",
  straightLineView: "lease.straight_line.view",
  straightLinePost: "lease.straight_line.post",
  reportView: "lease.report.view",
  settingsView: "lease.settings.view",
} as const;

/** Plan module of the leasing screens (P6). */
export const leaseModule = "leasing";

/** Settings page group of the leasing settings. */
export const leaseSettingsGroup = "lease";
